<template lang="pug">
.login
   div(class="pt-2 mb-4 md:mb-9")
      div(class="z-10 flex flex-col items-center justify-center md:mt-6")
         .container.mt-8.mb-8
            h1.mb-4.text-white {{msg}}
            h2.mb-9.text-white {{msg2}}
            a(@click="login" :href="url" target="blank" class="btn-gootics font-bold py-4 px-8 text-xl rounded") Free log in with Google

   .container.mx-auto
    .flex.mt-9
      site-box(:page="page1")
      site-box(class="hidden md:block lg:block xl:block" :page="page2")
   </template>

<script>
import axios from 'axios'
import SiteBox from '@/components/modules/SiteBoxDemo'

export default {
  name: 'LoginEx',
  store: ['colorMode'],
  components: {
    SiteBox
  },
  data () {
    return {
      msg: 'Google analytics bliss for your websites',
      msg2: 'A beautiful, configurable dashboard to monitor all your sites at a glance',
      url: '/api/auth/login',
      page1: {
        'name': 'gootics.com',
        'favicon': '/static/favicon-96x96.png',
        'settings': {
          'timeframe': 'thisMonth',
          'bigNumber': 'realtime',
          'graph': 'ga:users',
          'topLeft': 'ga:users',
          'topRight': 'ga:pageviews',
          'bottomLeft': 'ga:avgSessionDuration',
          'bottomRight': 'ga:bounceRate',
          'order': 2
        },
        'data': {
          'totals': {
            'ga:users': '9469',
            'ga:pageviews': '18752',
            'ga:avgSessionDuration': '01:45',
            'ga:bounceRate': '68.71 %'
          },
          'realtime': 12,
          'graph': {
            'datasets': [{
              'label': 'Site Visitors',
              'backgroundColor': 'transparent',
              'data': ['1400', '1256', '1252', '1086', '1591', '1571', '1313']
            }],
            'labels': ['18/04/11', '18/04/12', '18/04/13', '18/04/14', '18/04/15', '18/04/16', '18/04/17']
          }
        }
      },
      page2: {
        'name': 'producthunt.com',
        'favicon': 'https://www.producthunt.com/favicon.ico',
        'settings': {
          'timeframe': 'lastMonth',
          'bigNumber': 'realtime',
          'graph': 'ga:users',
          'topLeft': 'ga:users',
          'topRight': 'ga:pageviews',
          'bottomLeft': 'ga:avgSessionDuration',
          'bottomRight': 'ga:bounceRate',
          'order': 2
        },
        'data': {
          'totals': {
            'ga:users': '8050000',
            'ga:pageviews': '5.05',
            'ga:avgSessionDuration': '03:06',
            'ga:bounceRate': '47.44 %'
          },
          'realtime': 89,
          'graph': {
            'datasets': [{
              'label': 'Site Visitors',
              'backgroundColor': 'transparent',
              'data': ['201123', '205123', '301123', '181123', '203123', '123456', '191123', '221123', '211123', '251123', '271123', '301123', '311123', '201123', '191123', '241123', '245123', '235234', '191123', '301123', '271123', '261123', '208123', '301123', '281123', '201123', '213435', '241234', '181234', '221234', '234567']
            }],
            'labels': ['18/03/01', '18/03/02', '18/03/03', '18/03/04', '18/03/05', '18/03/06', '18/03/07', '18/03/08', '18/03/09', '18/03/10', '18/03/11', '18/03/12', '18/03/13', '18/03/14', '18/03/15', '18/03/16', '18/03/17', '18/03/18', '18/03/19', '18/03/20', '18/03/21', '18/03/22', '18/03/23', '18/03/24', '18/03/25', '18/03/26', '18/03/27', '18/03/28', '18/03/29', '18/03/30', '18/03/31']
          }
        }
      }
    }
  },
  created () {
    if (process.env.NODE_ENV === 'development') this.url = 'http://localhost:3245' + this.url

    // redirect to app if auth token present
    if (this.$route.query.token) {
      // handle auth callback and login
      localStorage.setItem('token', this.$route.query.token)
      this.setHeaders(this.$route.query.token)
      this.$router.push('/')
    } else if (localStorage.getItem('token')) {
      this.$router.push('/')
    } else {
      this.show = false
    }
  },
  methods: {
    setHeaders (token) {
      axios.defaults.headers.get['Auth'] = token
      axios.defaults.headers.post['Auth'] = token
      axios.defaults.headers.delete['Auth'] = token
      axios.defaults.headers.put['Auth'] = token
    },
    login () {
      console.log('do some stuff here?')
    },
    setMode (mode) {
      let body = document.body
      let oldClassName = 'lightmode'
      if (mode === 'lightmode') oldClassName = 'darkmode'
      this.colorMode = mode
      body.classList.remove(oldClassName)
      body.classList.add(mode)
      localStorage.setItem('darkmode', mode)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginEx.vue